import {
    IReadPostChapterItem,
    IReadPostItem,
    IReadPostSectionItem,
} from '../interfaces';
import {
    POST_CONTENT_SCOPE,
} from '../enums';

const isPreviewDependentScope = (
    item?: {
        paywalled?: boolean,
        authLocked?: boolean,
    } | null,
): boolean => !!(item?.paywalled || item?.authLocked);

const resolveEffectiveScopeAccess = (data: {
    post?: IReadPostItem | null,
    chapter?: IReadPostChapterItem,
    section?: IReadPostSectionItem,
}): {
    paywalled: boolean,
    authLocked: boolean,
} => {
    const {
        post,
        chapter,
        section,
    } = data;

    const chapterPaywalled = chapter?.paywalled ?? !!post?.paywalled;
    const chapterAuthLocked = chapter?.authLocked ?? !!post?.authLocked;

    return {
        paywalled: section?.paywalled ?? chapterPaywalled,
        authLocked: section?.authLocked ?? chapterAuthLocked,
    };
};

export const scopeSupportsPreviewCutoffForProductionPublish = (data: {
    post: IReadPostItem | null,
    selectedPostValuePath: number[],
    scope: POST_CONTENT_SCOPE,
}): boolean => {
    const {
        post,
        selectedPostValuePath,
        scope,
    } = data;

    if (!post) return false;

    if (scope === POST_CONTENT_SCOPE.root) {
        return (post.chapters?.length || 0) === 0;
    }

    if (scope === POST_CONTENT_SCOPE.chapter) {
        const chapter = (
            selectedPostValuePath.length > 0
            && post.chapters != null
            && selectedPostValuePath[0] != null
            && selectedPostValuePath[0] >= 0
            && selectedPostValuePath[0] < post.chapters.length
        )
            ? post.chapters[selectedPostValuePath[0]]
            : undefined;
        return (chapter?.sections?.length || 0) === 0;
    }

    return true;
};

export const scopeRequiresPreviewCutoffForProductionPublish = (data: {
    post: IReadPostItem | null,
    selectedPostValuePath: number[],
    scope: POST_CONTENT_SCOPE,
}): boolean => {
    const {
        post,
        selectedPostValuePath,
        scope,
    } = data;

    if (!post) return false;

    const chapter: IReadPostChapterItem | undefined = (
        selectedPostValuePath.length > 0
        && post.chapters != null
        && selectedPostValuePath[0] != null
        && selectedPostValuePath[0] >= 0
        && selectedPostValuePath[0] < post.chapters.length
    )
        ? post.chapters[selectedPostValuePath[0]]
        : undefined;
    const section: IReadPostSectionItem | undefined = (
        selectedPostValuePath.length > 1
        && chapter?.sections != null
        && selectedPostValuePath[1] != null
        && selectedPostValuePath[1] >= 0
        && selectedPostValuePath[1] < chapter.sections.length
    )
        ? chapter.sections[selectedPostValuePath[1]]
        : undefined;

    if (scope === POST_CONTENT_SCOPE.root) {
        return isPreviewDependentScope(post);
    }
    if (scope === POST_CONTENT_SCOPE.chapter) {
        return isPreviewDependentScope(resolveEffectiveScopeAccess({
            post,
            chapter,
        }));
    }
    if (scope === POST_CONTENT_SCOPE.section) {
        return isPreviewDependentScope(resolveEffectiveScopeAccess({
            post,
            chapter,
            section,
        }));
    }
    return false;
};
